import './MainLayout.css'
import React from 'react'
import { ChildrenProps } from '../../../modules/types'

export function MainLayout(props: ChildrenProps) {
  return (
    <main>
      <section id="content-container">
        {props.children}
      </section>
    </main>
  )
}
